import { Box, Typography } from '@mui/material';

export const ReportBreadcrumbToolbar = ({
  groupName,
  toolbarActions,
}: {
  groupName: string;
  toolbarActions?: React.ReactNode;
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      borderBottom: 1,
      borderColor: 'divider',
      padding: '4px 8px',
      gap: 0.5,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0, flex: 1 }}>
      <Typography variant='body2' noWrap sx={{ color: 'text.secondary', fontWeight: 500 }}>
        {groupName}
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>{toolbarActions}</Box>
  </Box>
);
